import { render, staticRenderFns } from "./OverlayModal.vue?vue&type=template&id=c77bdfc4&scoped=true&"
import script from "./OverlayModal.vue?vue&type=script&lang=js&"
export * from "./OverlayModal.vue?vue&type=script&lang=js&"
import style0 from "./OverlayModal.vue?vue&type=style&index=0&id=c77bdfc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77bdfc4",
  null
  
)

export default component.exports